import DocMarkdown from '@/components/DocMarkdown';

import { bridgeDocs } from './bridgeDocs';

/** 消息协议 tab：以 docs/bridge/004-messages 为入口，支持站内跳转到其它 bridge 文档。 */
export default function MessageProtocolTab() {
  return <DocMarkdown docs={bridgeDocs} docPath="bridge/004-messages/index.md" />;
}
